import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import Otherinfo from '../../../../Authorization/Otherinfo';
import { useDispatch } from 'react-redux';
import { getUseronboardingInfo } from '../../../../../actions/loginActions';

const UpdateUserInfo = ({ userData }) => {
    const [show, setShow] = useState(true);
    const dispatch = useDispatch();

    const handleClose = () => {
        setShow(false);
        localStorage.setItem('userInfoPopupClosed', 'true');
    };

    const onSubmit = () => {
        dispatch(getUseronboardingInfo());
        setShow(false);
        localStorage.setItem('userInfoPopupClosed', 'true');
    };

    return (
        <Modal className="userInfo-modal" show={show} onHide={handleClose} backdrop="static" keyboard={false} centered size={"md"}>
            <Modal.Body className='p-0' closeButton>
                <Otherinfo handleClose={handleClose} userData={userData} isHome={true} onSubmit={onSubmit}/>
            </Modal.Body>
        </Modal>
    );
};

export default UpdateUserInfo;